import { render, staticRenderFns } from "./FormAdicionarEmpresa.vue?vue&type=template&id=70ab3366"
import script from "./FormAdicionarEmpresa.vue?vue&type=script&lang=js"
export * from "./FormAdicionarEmpresa.vue?vue&type=script&lang=js"
import style0 from "./FormAdicionarEmpresa.vue?vue&type=style&index=0&id=70ab3366&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports